{
  "0_ALREADY_EXISTS": "\"{0}\" موجود بالفعل.",
  "0_OF_1": "{0} من {1}",
  "ACCOUNT_ID": "معرف الحساب",
  "ADD": "جمع",
  "ADD_REMOVE_FIELDS": "إضافة/إزالة الحقول",
  "AN_ERROR_OCCURED": "حدث خطأ",
  "APPLY": "طبق",
  "APPLY_CHANGES": "تطبيق التغييرات",
  "ATTACH": "ألحق",
  "ATTACH_AS_LINK": "إرفاق كرابط",
  "ATTACHING": "ارفاق...",
  "AUTOMATICALLY_RENAME": "إعادة التسمية تلقائيا",
  "BACK": "ظهر",
  "BROWSE": "تصفح",
  "CANCEL": "إلغاء الأمر",
  "CHARACTER_COUNT": "عدد الأحرف:",
  "CLOSE": "غلق",
  "CLOUD": "سحابة",
  "COMMENT": "التعليق",
  "CONFIGURE_REPOSITORY_SETTINGS": "تكوين إعدادات المستودع",
  "COULD_NOT_SAVE_0": "تعذر حفظ \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "تعذر حفظ \"{0}\". نوع الملف غير مدعوم.",
  "DATA": "بيانات",
  "DATE": "تاريخ",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "يجب أن تكون حقول التاريخ بالتنسيق {0}.",
  "DATE_PROVIDED_IS_INVALID": "التاريخ المقدم غير صالح.",
  "DATE_TIME": "التاريخ/الوقت",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "يجب أن تكون حقول التاريخ/الوقت بالتنسيق {0}.",
  "DEFAULT_FOLDER": "<المجلد الافتراضي>",
  "DETAILS": "التفاصيل",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "هل تريد تطبيق تغييرات الحقل؟",
  "DOCUMENT_NAME_IS_EMPTY": "اسم المستند فارغ",
  "DRAG_DROP_FILE": "سحب الملف وإفلاته",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "إدخال باسم '{0}موجود بالفعل في هذا المجلد. الرجاء تحديد اسم مختلف.",
  "ENTRY_ID": "معرف الدخول",
  "ENTRY_NAME": "اسم الإدخال",
  "ENTRY_NOT_FOUND": "لم يتم العثور على الإدخال.",
  "ERROR_DOWNLOADING_DOCUMENT": "خطأ في تنزيل المستند.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "حدث خطأ أثناء الاتصال بالخادم.",
  "ERROR_SAVING": "خطأ في الحفظ:",
  "FAILED_TO_OPEN_FOLDER": "فشل فتح المجلد",
  "FAILED_TO_SAVE_COLON": "فشل الحفظ:",
  "FAILED_TO_SAVE_PERIOD": "فشل الحفظ.",
  "FEEDBACK": "ردود الفعل",
  "FIELDS": "حقول",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "يتجاوز هذا الملف الحد الأقصى لحجم الملف البالغ 25 ميجابايت.",
  "FILE_EXTENSION": "امتداد الملف",
  "FILE_LOCKED": "الملف مقفل.",
  "FILE_MODIFIED": "تم تعديل الملف",
  "FILE_NAME": "اسم الملف",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "لا يمكن أن تحتوي أسماء الملفات على شرطة مائلة للخلف",
  "FOLDER": "مجلد",
  "INTEGER": "العدد الصحيح",
  "LIST": "قائمة",
  "LOADING": "تحميل...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "يجب أن تكون الحقول الطويلة أعدادا صحيحة بين 0 و 3,999,999,999",
  "LONG_INTEGER": "عدد صحيح طويل",
  "NAME": "اسم",
  "NAME_CONFLICT": "تعارض الأسماء",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "هل تحتاج إلى مساعدة في تسجيل الدخول؟ اتصل بمسؤول Laserfiche للحصول على المساعدة.",
  "NEW_FOLDER": "مجلد جديد",
  "NO": "لا",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "لا توجد حقول إضافية معينة",
  "NO_FOLDER_SELECTED": "لم يتم تحديد أي مجلد.",
  "NO_MATCHING_ENTRIES_FOUND": "لم يتم العثور على إدخالات مطابقة",
  "NO_MATCHING_FIELDS_FOUND": "لم يتم العثور على حقول مطابقة.",
  "NO_TEMPLATE_ASSIGNED": "لم يتم تعيين قالب",
  "NOT_AVAILABLE_WITH_TOKENS": "غير متوفر مع الرموز المميزة",
  "NUMBER": "رقم",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "يجب أن يكون حقل الرقم رقما صالحا",
  "OK": "موافق",
  "ONE_OR_MORE_FIELDS_INVALID": "حقل واحد أو أكثر غير صالح.",
  "OPEN": "مفتوح",
  "OPEN_IN_LASERFICHE": "مفتوح في Laserfiche",
  "OPTIONAL": "اختياري",
  "OR": "أو",
  "PARENT_FIELD": "الحقل الأصلي",
  "PARENT_ID": "معرف الوالدين",
  "PARENT_NAME": "اسم الوالد",
  "PLEASE_SELECT_A_FOLDER": "الرجاء تحديد مجلد",
  "REASON_FOR_DOWNLOADING": "سبب التنزيل",
  "REFRESH": "تحديث",
  "REMOVE": "أبعد",
  "REMOVE_REPOSITORY": "إزالة المستودع؟",
  "REPOSITORY": "مستودع",
  "REPOSITORY_COUNT": "عدد المستودعات",
  "REPOSITORY_ID": "معرف المستودع",
  "REPOSITORY_NAME": "اسم المستودع",
  "REQUIRED": "مطلوب",
  "REQUIRED_FIELD_IS_EMPTY": "الحقل المطلوب فارغ",
  "SAVE_CHANGES": "حفظ التغييرات",
  "SAVE_TO_LASERFICHE": "حفظ في Laserfiche",
  "SAVED_TO_LASERFICHE": "تم الحفظ في Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "تم الحفظ في Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "تم الحفظ مع البيانات الوصفية المفقودة:",
  "SAVING": "حفظ...",
  "SEARCH_FIELDS": "البحث في الحقول",
  "SELECT": "اختار",
  "SELECT_REASON": "حدد سببا",
  "SELF_HOSTED": "استضافة ذاتية",
  "SESSION_COUNT": "عدد الجلسات",
  "SETTINGS": "اعدادات",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "يجب أن تكون الحقول القصيرة أعدادا صحيحة بين 0 و 64999",
  "SIGN_IN": "تسجيل الدخول",
  "SIGN_IN_TO_LASERFICHE": "تسجيل الدخول إلى Laserfiche",
  "SIGN_OUT": "تسجيل الخروج",
  "SIGNING_IN": "تسجيل الدخول...",
  "SIGNING_OUT": "تسجيل الخروج...",
  "SKIP_THIS_FILE": "تخطي هذا الملف",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقا.",
  "SUBMIT": "إرسال",
  "SUGGESTION": "اقتراح",
  "TEMPLATE": "قالب",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "فشل تحميل القالب.",
  "TEXT": "نص",
  "THANK_YOU_FOR_SUBMISSION": "شكرا لك على تقديمك!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "الحد الأقصى المسموح به لهذا الحقل هو {0} الاحرف.",
  "THIS_FOLDER_IS_EMPTY": "هذا المجلد فارغ.",
  "TIME": "الوقت",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "يجب أن تكون حقول الوقت بالتنسيق {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "تعذر تحميل جميع الحقول:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "يتعذر استرداد معلومات المستودع:",
  "UNKNOWN_ERROR": "خطأ غير معروف.",
  "USER_NAME": "اسم المستخدم",
  "YES": "نعم"
}
